module.exports = __webpack_public_path__ + "img/pwa_install_screen_confirm.4b4e0c82.png";